module.exports = __webpack_public_path__ + "static/media/ebs.df85a0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/ebs.png
// module id = 452
// module chunks = 0